module.exports = __webpack_public_path__ + "5501c58597c211eb6f31a52f37cd6ddc.jpg";